import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BehaviorSubject, Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { Event } from '../models/event/event';
import { Error } from '../models/error/error';
import { ApiService } from '../service/api.service';
import { AlertModalService } from '../component/alertmodal/alertmodal.service';
import { AlertBlockService } from '../component/alertblock/alertblock.service';
import { MenuService } from '../component/menu/menu.service';
import { PopStateService } from '../service/popstate.service';
import { ColumnService } from '../items/columns/column/column.service';
import { ValidationService } from '../service/validation.service';
import { TabService } from '../component/tab/tab.service';
import { LogService } from '../service/log.service';
import { CommonAction } from './common.action';
import { ApiAction } from './api.action';
import { ReflectionAction } from './reflection.action';
import { ConditionAction } from './condition.action';
import { BulkAction } from './bulk.action';
var ActionData = /** @class */ (function () {
    function ActionData() {
        this.rec = {};
        this.response = {};
        this.error = new Error();
        this.targetComponents = [];
    }
    return ActionData;
}());
var AuAction = /** @class */ (function () {
    function AuAction(router, location, logger, api, alertModalService, alertBlockService, menuService, popStateService, columnService, validService, tabService, logService, commonAction, apiAction, reflectionAction, conditionAction, bulkAction) {
        this.router = router;
        this.location = location;
        this.logger = logger;
        this.api = api;
        this.alertModalService = alertModalService;
        this.alertBlockService = alertBlockService;
        this.menuService = menuService;
        this.popStateService = popStateService;
        this.columnService = columnService;
        this.validService = validService;
        this.tabService = tabService;
        this.logService = logService;
        this.commonAction = commonAction;
        this.apiAction = apiAction;
        this.reflectionAction = reflectionAction;
        this.conditionAction = conditionAction;
        this.bulkAction = bulkAction;
        this.msg = {}; // meta.messages
        this.rec = {};
        this.compRec = {};
        this._actionSubject = new Subject();
        this._refSubject = new BehaviorSubject([]);
        this._modeSubject = new BehaviorSubject('');
        this._eventSubject = new Subject();
        this._changeSubject = new Subject();
        this._modalSubject = new Subject();
        this._errorSubject = new Subject();
        this.setActionSubject();
    }
    AuAction.prototype.setInit = function (state, meta, msg) {
        this.logger.debug('state:', state);
        this.logger.debug('events:', meta.events);
        this.state = state;
        this.initEvents = meta.events;
        this.msg = msg;
        this.rec = {};
        this.compRec = {};
        this.actionData = {};
        this._refSubject.next([]);
        this._modeSubject.next('');
        this.commonAction.setInit(state, this.router.routerState.snapshot.root.queryParams);
        this.apiAction.setInit();
        this.columnService.setInit();
        this.validService.setMeta(meta);
        this.alertBlockService.setMeta(meta);
        this.tabService.checkTab();
    };
    Object.defineProperty(AuAction.prototype, "refObservable", {
        get: function () {
            return this._refSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuAction.prototype, "modeObservable", {
        get: function () {
            return this._modeSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuAction.prototype, "eventObservable", {
        get: function () {
            return this._eventSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuAction.prototype, "changeObservable", {
        get: function () {
            return this._changeSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuAction.prototype, "modalObservable", {
        get: function () {
            return this._modalSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuAction.prototype, "errorObservable", {
        get: function () {
            return this._errorSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AuAction.prototype.setEvents = function (events) {
        this.initEvents = events;
    };
    AuAction.prototype.setMsg = function (msg) {
        this.msg = msg;
    };
    AuAction.prototype.setRec = function (rec) {
        this.logger.debug('setRec', rec);
        this.rec = rec;
    };
    AuAction.prototype.deleteCompRec = function (key) {
        delete this.compRec[key];
        this._changeSubject.next(this.compRec);
    };
    AuAction.prototype.setCompRec = function (key, rec) {
        this.logger.debug('setCompRec:', key, rec);
        this.compRec[key] = rec;
        this._changeSubject.next(this.compRec);
    };
    AuAction.prototype.getCompRec = function (key) {
        if (key) {
            return this.compRec[key];
        }
        else {
            return this.compRec;
        }
    };
    AuAction.prototype.setError = function (initEvent, error) {
        if (typeof initEvent !== 'undefined' && typeof this.actionData[initEvent] !== 'undefined' && typeof this.actionData[initEvent].error !== 'undefined') {
            this.actionData[initEvent].error = error;
        }
    };
    AuAction.prototype.getEvent = function (e) {
        var event = new Event();
        if (e !== '' && typeof e !== 'undefined' && typeof this.initEvents !== 'undefined' && typeof this.initEvents[e] !== 'undefined') {
            event = this.initEvents[e];
        }
        return event;
    };
    AuAction.prototype.validEvent = function (event) {
        return (typeof this.getEvent(event).action !== 'undefined');
    };
    AuAction.prototype.firstAction = function (e, params) {
        if (params === void 0) { params = {}; }
        if (typeof params !== 'object') {
            // firstAction()の第二引数を「btnType: string」から「params: { buttonType?: string, queryGroupName?: string, log?: boolean }」に変更したので、
            // 型がobjectではない場合、後続の処理は行わない
            this.logger.error('different type:', params);
            return;
        }
        if (e !== '' && typeof e !== 'undefined') {
            var rec = this.rec;
            var targetComponents = [];
            if (params && params.buttonType) {
                var error = new Error();
                this._errorSubject.next({ error: error, targetComponents: [] });
                this.alertBlockService.alert(error);
                this.columnService.addValidationError(error);
                var valid = this.validService.validation(params.buttonType, this.getEvent(e), this.compRec, this.msg);
                targetComponents = valid.targetComponents;
                if (Object.keys(valid.data).length > 0) {
                    rec = valid.data;
                }
                if (!valid.validation) {
                    return;
                }
            }
            var log = false;
            if (!params || params.log !== false) {
                log = true;
            }
            this.actionData[e] = {
                events: this.initEvents,
                rec: rec,
                queryGroupName: (params && params.queryGroupName ? params.queryGroupName : ''),
                response: {},
                error: new Error(),
                targetComponents: targetComponents
            };
            this.setRec({});
            this.action(e, e, log);
        }
    };
    AuAction.prototype.action = function (initEvent, e, log) {
        if (log === void 0) { log = false; }
        this.logger.debug('initEvent:', initEvent, ', currentEvent:', e);
        if (initEvent !== '' && typeof initEvent !== 'undefined' && e !== '' && typeof this.actionData[initEvent] !== 'undefined') {
            if (typeof this.actionData[initEvent].events !== 'undefined' && typeof this.actionData[initEvent].events[e] !== 'undefined') {
                if (log) {
                    this.logService.setLog(e);
                }
                var event_1 = this.actionData[initEvent].events[e];
                this.logger.debug('events:', event_1);
                this.actionData[initEvent].events = event_1.events;
                this._actionSubject.next({ initEvent: initEvent, event: event_1 });
            }
            else {
                delete this.actionData[initEvent];
                this._eventSubject.next(e);
            }
        }
        else {
            this._eventSubject.next(e);
        }
    };
    AuAction.prototype.setActionSubject = function () {
        var _this = this;
        this._actionSubject.subscribe(function (data) {
            var initEvent = data.initEvent;
            var event = data.event;
            var actionData = _this.actionData[initEvent];
            switch (event.action) {
                case 'Api':
                    var apiParams = _this.apiAction.getUrl(event.params, actionData.response, actionData.rec, _this.compRec, actionData.queryGroupName);
                    _this.api.execApi(apiParams.params, apiParams.url, apiParams.rec, apiParams.query)
                        .subscribe(function (rec) {
                        actionData.response = rec;
                        if (_this.api.getIsStop()) {
                            _this.firstAction('Nop');
                        }
                        else {
                            _this.action(initEvent, 'true');
                        }
                    }, function (error) {
                        actionData.error = error;
                        if (error.code || _this.api.getIsStop()) {
                            _this.firstAction('Nop');
                        }
                        else {
                            _this.action(initEvent, 'false');
                        }
                    });
                    break;
                case 'AlertModal':
                    _this.alertModalService.open(event.params, actionData.error, initEvent);
                    _this._errorSubject.next({ error: actionData.error, targetComponents: actionData.targetComponents });
                    _this.alertBlockService.alert(actionData.error, actionData.targetComponents);
                    _this.columnService.addValidationError(actionData.error, actionData.targetComponents);
                    break;
                case 'Reflection':
                    var refParams = _this.reflectionAction.getTargets(event.params, actionData.response);
                    _this._refSubject.next(refParams);
                    _this.columnService.reflection(refParams);
                    _this.action(initEvent, 'done');
                    break;
                case 'Clear':
                    var clearParams = _this.reflectionAction.getTargets(event.params, {});
                    _this._refSubject.next(clearParams);
                    _this.action(initEvent, 'done');
                    break;
                case 'Transition':
                    var transParams = _this.apiAction.getUrl(event.params, actionData.response, actionData.rec, _this.compRec, actionData.queryGroupName);
                    var trans_url = transParams.url;
                    _this.logger.debug('url:', trans_url);
                    if (trans_url.match(/^http/)) {
                        window.open(trans_url, trans_url);
                    }
                    else {
                        var params = {};
                        var url = trans_url.split('?');
                        if (url.length == 2) {
                            for (var _i = 0, _a = url[1].split('&'); _i < _a.length; _i++) {
                                var param = _a[_i];
                                var p = param.split('=');
                                params[p[0]] = p[1];
                            }
                        }
                        _this.menuService.pushUrl(trans_url);
                        _this.router.navigate([url[0]], { queryParams: params });
                    }
                    break;
                case 'Back':
                    _this.popStateService.setActionBack(true);
                    _this.menuService.popUrl();
                    _this.location.back();
                    break;
                case 'Condition':
                    _this.action(initEvent, _this.conditionAction.checkCondition(event.params, actionData.response, actionData.rec));
                    break;
                case 'Mode':
                    var mode = event.params && event.params['mode'] ? event.params['mode'] : '';
                    _this._modeSubject.next(mode);
                    _this.action(initEvent, 'done');
                    break;
                case 'Bulk':
                    var bulkRes_1 = [];
                    _this.bulkAction.exec(event.params, actionData.rec)
                        .subscribe(function (data) {
                        bulkRes_1 = data;
                    }, function (error) {
                    }, function () {
                        var bulkParams = _this.reflectionAction.getTargets(event.params, bulkRes_1);
                        _this._refSubject.next(bulkParams);
                        _this.action(initEvent, 'done');
                    });
                    break;
                case 'DownLoad':
                    var linkParams = _this.apiAction.getUrl(event.params, actionData.response, actionData.rec, _this.compRec, actionData.queryGroupName);
                    _this.logger.debug('url:', linkParams.url);
                    window.location.href = _this.api.makeUrlWithParams(linkParams.url, linkParams.query);
                    _this.action(initEvent, 'done');
                    break;
                case 'OpenModal':
                    var openModalParams = _this.reflectionAction.getTargets(event.params, {});
                    _this._modalSubject.next(Object.assign({ event: 'open' }, openModalParams[0]));
                    _this.action(initEvent, 'done');
                    break;
                case 'CloseModal':
                    _this._modalSubject.next({ event: 'close' });
                    _this.action(initEvent, 'done');
                    break;
                case 'Nop':
                    delete _this.actionData[initEvent];
                    break;
                default:
                    break;
            }
        });
    };
    AuAction.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AuAction.ctorParameters = function () { return [
        { type: Router },
        { type: Location },
        { type: NGXLogger },
        { type: ApiService },
        { type: AlertModalService },
        { type: AlertBlockService },
        { type: MenuService },
        { type: PopStateService },
        { type: ColumnService },
        { type: ValidationService },
        { type: TabService },
        { type: LogService },
        { type: CommonAction },
        { type: ApiAction },
        { type: ReflectionAction },
        { type: ConditionAction },
        { type: BulkAction }
    ]; };
    return AuAction;
}());
export { AuAction };
//# sourceMappingURL=au.action.js.map